import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BrowserLanguageService } from '../../services/geo-language.service';

@Component({
	selector: 'app-select-language-popover',
	templateUrl: './select-language-popover.component.html',
	styleUrls: ['./select-language-popover.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectLanguagePopoverComponent {
	public selectedLanguage: string;

	public listCountries = [
		{
			name: 'German',
			icon: '../../../assets/de.svg',
			value: 'de',
		},
		{
			name: 'English',
			icon: '../../../assets/en.svg',
			value: 'en',
		},
		{
			name: 'French',
			icon: '../../../assets/fr.svg',
			value: 'fr',
		},
	];
	constructor(
		private popover: PopoverController,
		private translate: TranslateService,
		private browserLanguageService: BrowserLanguageService
	) {
		this.selectedLanguage = this.translate.currentLang;
	}

	dismissWithData(selectedLanguage: string) {
		// Use BrowserLanguageService for consistent language management
		this.browserLanguageService.changeLanguage(selectedLanguage);
		this.dismiss(selectedLanguage);
	}
	dismiss(data?: string) {
		this.popover.dismiss(data);
	}
}
